import React, { useState } from 'react';
import { useTracking } from '../lib/context/TrackingContext';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

interface ABTestDebuggerProps {
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

const ABTestDebugger: React.FC<ABTestDebuggerProps> = ({ position = 'bottom-right' }) => {
  const [expanded, setExpanded] = useState(false);
  const { currentVariant } = useTracking();
  
  // Only show in development mode
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  
  // Position styles
  const positionStyles = {
    'top-left': 'top-4 left-4',
    'top-right': 'top-4 right-4',
    'bottom-left': 'bottom-4 left-4',
    'bottom-right': 'bottom-4 right-4',
  };
  
  return (
    <div 
      className={`fixed ${positionStyles[position]} z-50`}
      style={{ opacity: 0.9 }}
    >
      {expanded ? (
        <div className="bg-white p-4 rounded-lg shadow-lg border border-gray-200 w-64">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-bold text-sm">A/B Test Debugger</h3>
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={() => setExpanded(false)}
              className="h-6 w-6 p-0"
            >
              ×
            </Button>
          </div>
          
          <div className="space-y-2 text-sm">
            <div>
              <span className="text-gray-500">Current Variant:</span>
              <div className="flex items-center gap-2 mt-1">
                <Badge className="bg-blue-100 text-blue-800">
                  {currentVariant || 'None'}
                </Badge>
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="h-6 text-xs"
                  onClick={() => {
                    localStorage.removeItem('abtest_landing_page_variations');
                    window.location.href = '/';
                  }}
                >
                  Reset
                </Button>
              </div>
            </div>
            
            <div>
              <span className="text-gray-500">Test Variants:</span>
              <div className="flex flex-wrap gap-2 mt-1">
                {['exhausted', 'sdr-cost', 'soul', 'clicker'].map(variant => (
                  <Button
                    key={variant}
                    variant="outline"
                    size="sm"
                    className={`h-6 text-xs ${currentVariant === variant ? 'bg-blue-50' : ''}`}
                    onClick={() => {
                      localStorage.setItem('abtest_landing_page_variations', variant);
                      window.location.href = '/';
                    }}
                  >
                    {variant}
                  </Button>
                ))}
              </div>
            </div>
            
            <div className="pt-2 border-t border-gray-200">
              <Button 
                variant="default" 
                size="sm" 
                className="w-full text-xs"
                onClick={() => window.location.href = '/abtest-dashboard'}
              >
                View Dashboard
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <Button 
          variant="outline" 
          size="sm" 
          onClick={() => setExpanded(true)}
          className="bg-white shadow-md"
        >
          A/B
        </Button>
      )}
    </div>
  );
};

export default ABTestDebugger; 